"use client";

import { useRouter } from "next/navigation";

import { CheckboxFacet } from "./checkbox-facet";
import { buildItemSearchUrl, type ItemSearchParams } from "@/lib/item-search-params";
import type { FacetCount } from "./types";

export function StoreFacet({ facets, params }: { facets: FacetCount[]; params: ItemSearchParams }) {
  const router = useRouter();

  return (
    <CheckboxFacet
      title="Store"
      facets={facets}
      selected={params.storeId}
      onChange={(next) => router.push(buildItemSearchUrl(params, { storeId: next }))}
      searchThreshold={9999}
    />
  );
}
